import Vue from "vue";
import Router from "vue-router";
import store, { MU_UPATE_AUTH } from "store";
import managerRouter from "./manager";
import { utStudent, utTeacher, utMSite, utMSystem,utEJSystem, utMSchool } from "../api/v1.commom.login.ts";
Vue.use(Router);

const router = new Router({
    mode: "history",
    routes: [
        {
            path: "/wlx/",
            name: "xIndex",
            props: true,
            component: () => import("page/xSchool/xIndex.vue"),
            redirect: { name: "xHome" },
            meta: {
                title: "1+X试点",
            },
            children: [
                // 资源查看
                {
                    path: "imagesView",
                    name: "imagesView",
                    props: true,
                    component: () => import("page/imagesView.vue"),
                    meta: {
                        title: "1+X试点首页",
                    },
                },
                {
                    path: "home",
                    name: "xHome",
                    props: true,
                    component: () => import("page/xSchool/xhome.vue"),
                    meta: {
                        title: "1+X试点首页",
                    },
                },
                {
                    path: "downLoad/:type?",
                    name: "downLoad",
                    props: true,
                    component: () => import("page/xSchool/downLoad.vue"),
                    meta: {
                        title: "考试软件下载",
                    },
                },
                {
                    path: "meetRegister",
                    name: "meetRegister",
                    props: true,
                    component: () => import("page/xSchool/meetSignUp.vue"),
                    meta: {
                        title: "会议报名",
                    },
                },
                {
                    path: "mockCertifySelect",
                    name: "mockCertifySelect",
                    props: true,
                    component: () => import("page/xSchool/mockCertifySelect.vue"),
                    meta: {
                        title: "模拟练习证书选择",
                    },
                },
                {
                    path: "meetRegister/:meetId",
                    name: "meetSignUpDetail",
                    props: true,
                    component: () => import("page/xSchool/meetDetail.vue"),
                    meta: {
                        title: "会议报名详情",
                    },
                },
                // 培训报名
                {
                    path: "trainRegister",
                    name: "trainRegister",
                    props: true,
                    component: () => import("page/xSchool/trainSign/trainSignUp.vue"),
                    meta: {
                        title: "培训报名",
                    },
                },
                {
                    path: "trainRegister/:trainId",
                    name: "trainRegisterDetail",
                    props: true,
                    component: () => import("page/xSchool/trainSign/trainDetail.vue"),
                    meta: {
                        title: "培训报名详情",
                    },
                },
                {
                    path: "trainRegister/NeiBu/:trainId",
                    name: "trainDetailNeiBu",
                    props: true,
                    component: () => import("page/xSchool/trainSign/trainDetailNeiBu.vue"),
                    meta: {
                        title: "培训报名详情",
                    },
                },
                {
                    path: "SynthesisImg",
                    name: "SynthesisImg",
                    props: true,
                    component: () => import("page/component/SynthesisImg/SynthesisImg.vue"),
                    meta: {
                        title: "图片合成",
                    },
                },
                {
                    path: "news",
                    name: "xNewsCenter",
                    props: true,
                    component: () => import("page/xSchool/newsCenter.vue"),
                    meta: {
                        title: "新闻中心",
                    },
                },
                {
                    path: "news/:newsId/newsDetail",
                    name: "newsDetail",
                    props: true,
                    component: () => import("page/xSchool/newCenterDetail.vue"),
                    meta: {
                        title: "新闻详情",
                    },
                },
                {
                    path: "activity",
                    name: "themeActivity",
                    props: true,
                    component: () => import("page/xSchool/themeActivity.vue"),
                    meta: {
                        title: "专题活动",
                    },
                    redirect: { name: "alseActivity" },
                    children: [
                        {
                            path: "alseActivity",
                            name: "alseActivity",
                            props: true,
                            component: () => import("page/xSchool/alseActivity.vue"),
                            meta: {
                                title: "其他活动",
                            },
                        },
                    ],
                },
                // {
                //     path: 'activity/:activityId',
                //     name: 'activityDetail',
                //     props: true,
                //     component: () =>
                //         import ('page/xSchool/themeActivity.vue'),
                //     meta: {
                //         title: '专题活动详情'
                //     }
                // },
                {
                    path: "certifiActiv",
                    name: "certifiActiv",
                    props: true,
                    component: () => import("page/xSchool/certificationActivities.vue"),
                    meta: {
                        title: "认证活动",
                    },
                },
                {
                    path: "certifiActiv/:activityId/certifiActivList",
                    name: "certifiActivList",
                    props: true,
                    component: () => import("page/xSchool/certificationActivitiesList.vue"),
                    meta: {
                        title: "认证活动详情",
                    },
                },
                {
                    path: "site",
                    name: "certifySite",
                    props: true,
                    component: () => import("page/xSchool/certifySite.vue"),
                    meta: {
                        title: "认证站点",
                    },
                },
                {
                    path: "site/:id/activityDetail",
                    name: "siteActivityDetail",
                    props: true,
                    component: () => import("page/xSchool/siteActivityDetail.vue"),
                    meta: {
                        title: "认证站点活动详情",
                    },
                },
                {
                    path: "certifLecturer",
                    name: "certifLecturer",
                    props: true,
                    component: () => import("page/xSchool/certificationLecturer.vue"),
                    meta: {
                        title: "认证讲师",
                    },
                },
                {
                    path: "certificateStu",
                    name: "certificateStu",
                    props: true,
                    component: () => import("page/xSchool/certificateStudent.vue"),
                    meta: {
                        title: "认证学员",
                    },
                },
                {
                    path: "standard",
                    name: "standard",
                    props: true,
                    component: () => import("page/xSchool/certifyStandard.vue"),
                    meta: {
                        title: "认证标准",
                    },
                },
                {
                    path: "standard/:id/standardDetail",
                    name: "standardDetail",
                    props: true,
                    component: () => import("page/xSchool/certifyStandardDetail.vue"),
                    meta: {
                        title: "认证标准详情",
                    },
                },
                {
                    path: "test",
                    name: "certifyTest",
                    props: true,
                    component: () => import("page/xSchool/certifyTest.vue"),
                    meta: {
                        title: "认证考试",
                    },
                },
                {
                    path: "learnMaterial",
                    name: "learnMaterial",
                    props: true,
                    component: () => import("page/xSchool/learnMaterial.vue"),
                    meta: {
                        title: "学习资料",
                    },
                },
                // {
                //     path: 'certifyQuery',
                //     name: 'certifyQuery',
                //     props: true,
                //     component: () =>
                //         import ('page/xSchool/certifyQuery.vue'),
                //     meta: {
                //         title: '证书查询'
                //     }
                // },
                {
                    path: "examResult",
                    name: "examResultQuery",
                    props: true,
                    component: () => import("page/xSchool/examResultQuery.vue"),
                    meta: {
                        title: "考试结果查询",
                    },
                },
                {
                    path: "studySource",
                    name: "studySource",
                    props: true,
                    component: () => import("page/xSchool/studySource.vue"),
                    meta: {
                        title: "学习资源",
                    },
                },
                {
                    path: "intro",
                    name: "xIntro",
                    props: true,
                    redirect: { name: "knowLogistics" },
                    component: () => import("page/xSchool/logisticsIntro.vue"),
                    meta: {
                        title: "物流x介绍",
                    },
                    children: [
                        {
                            path: "know",
                            name: "knowLogistics",
                            props: true,
                            component: () => import("page/xSchool/knowLogistics.vue"),
                            meta: {
                                title: "了解物流X",
                            },
                        },
                        {
                            path: "authenticationCenter",
                            name: "authenticationCenter",
                            props: true,
                            component: () => import("page/xSchool/authenticationCenter.vue"),
                            meta: {
                                title: "认证中心",
                            },
                        },
                        {
                            path: "textualResearch",
                            name: "textualResearch",
                            props: true,
                            component: () => import("page/xSchool/textualResearch.vue"),
                            meta: {
                                title: "我要考证",
                            },
                        },
                    ],
                },
                {
                    path: "enterprise",
                    name: "enterprise",
                    props: true,
                    component: () => import("page/xSchool/cooperateEnterprise.vue"),
                    meta: {
                        title: "合作企业",
                    },
                },
                {
                    path: "register",
                    name: "register",
                    props: true,
                    component: () => import("page/xSchool/registerAccount.vue"),
                    meta: {
                        title: "账号注册",
                    },
                },
                {
                    path: "introIndex",
                    name: "introIndex",
                    props: true,
                    component: () => import("page/xSchool/intro/index.vue"),
                    meta: {
                        title: "项目介绍",
                    },  
                },
                {
                    path: "introIndex/:certifyId",
                    name: "introMain",
                    props: true,
                    component: () => import("page/xSchool/intro/certifycateIndex.vue"),
                    redirect:{ name:'Introduction' },
                    meta: {
                        title: "项目介绍",
                    },  
                    children:[
                        {
                            path: "introduce",
                            name: "Introduction",
                            props: true,
                            component: () => import("page/xSchool/introContent.vue"),
                            meta: {
                                title: "产品",
                            },
                            redirect: { name: "introBase" },
                            children: [
                                {
                                    path: "base",
                                    name: "introBase",
                                    props: true,
                                    component: () => import("page/xSchool/introBasic.vue"),
                                    meta: {
                                        title: "基本建设",
                                    },
                                },
                                {
                                    path: "standard",
                                    name: "introStandard",
                                    props: true,
                                    component: () => import("page/xSchool/introStandard.vue"),
                                    meta: {
                                        title: "标准建设",
                                    },
                                },
                                {
                                    path: "managerWordList",
                                    name: "managerWordList",
                                    props: true,
                                    component: () => import("page/xSchool/managerWordList.vue"),
                                    meta: {
                                        title: "管理办法",
                                    },
                                },
                                {
                                    path: "managerWord/:managerWordId/managerWordDetail",
                                    name: "managerWordDetail",
                                    props: true,
                                    component: () => import("page/xSchool/managerWordDetail.vue"),
                                    meta: {
                                        title: "管理办法详情",
                                    },
                                },
                                {
                                    path: "examOutLineList",
                                    name: "examOutLineList",
                                    props: true,
                                    component: () => import("page/xSchool/examOutLineList.vue"),
                                    meta: {
                                        title: "考核大纲",
                                    },
                                },
                                {
                                    path: "examOutLine/:examOutLineId/examOutLineDetail",
                                    name: "examOutLineDetail",
                                    props: true,
                                    component: () => import("page/xSchool/examOutLineDetail.vue"),
                                    meta: {
                                        title: "考核大纲详情",
                                    },
                                },
                               
                            ],
                        },
                    ]
                },
               
                {
                    path: "aboutUs",
                    name: "aboutUs",
                    props: true,
                    component: () => import("page/xSchool/aboutUs.vue"),
                    meta: {
                        title: "关于我们",
                    },
                },
                {
                    path: "BookCenter",
                    name: "textBookCenter",
                    props: true,
                    component: () => import("page/xSchool/textBookCenter.vue"),
                    meta: {
                        title: "教材中心",
                    },
                },
                {
                    path: "studyCenter",
                    name: "studyCenter",
                    props: true,
                    component: () => import("page/xSchool/studyCenter/studyCennter.vue"),
                    meta: {
                        title: "学习中心",
                    },
                    children: [
                        {
                            path: "metarialCenter",
                            name: "metarialCenter",
                            props: true,
                            component: () => import("page/xSchool/studyCenter/metarialCenter.vue"),
                            meta: {
                                title: "教材中心",
                            },
                        },
                        {
                            path: "metarialCenter/:bookId",
                            name: "teachingDetails",
                            props: true,
                            component: () => import("page/xSchool/teachingDetails.vue"),
                            meta: {
                                title: "教材详情",
                            },
                        },
                        {
                            path: "videoChart/:videoType?",
                            name: "videoChart",
                            props: true,
                            component: () => import("page/xSchool/studyCenter/videoList.vue"),
                            meta: {
                                title: "串讲视频",
                            },
                        },
                        {
                            path: "videoDetail/:videoId",
                            name: "videoDetail",
                            props: true,
                            meta: {
                                title: "串讲视频详情",
                            },
                            component: () => import("page/xSchool/studyCenter/videoDetail.vue"),
                        },
                    ],
                },
                // {
                //   path: 'BookCenter/:bookId',
                //   name: 'teachingDetails',
                //   props: true,
                //   component: () => import ('page/xSchool/teachingDetails.vue'),
                //   meta: {
                //     title: '教材详情',
                //   },
                // },
                {
                    path: ":resId/bookDetail",
                    name: "book",
                    props: true,
                    component: () => import("page/xSchool/work.vue"),
                    meta: {
                        title: "教材详情-作业",
                    },
                },
                // 绘制证书
                {
                    path: "certifyDraw",
                    name: "certifyDraw",
                    props: true,
                    component: () => import("page/xSchool/cerfityDraw.vue"),
                    meta: {
                        title: "证书绘制",
                    },
                },
                {
                    path: "teaTraining",
                    name: "teaTraining",
                    props: true,
                    component: () => import("page/xSchool/teaTraining.vue"),
                    meta: {
                        title: "师资培训",
                    },
                },
            ],
        },
        // #region 管理员路由
        {
            path: "/wlx/system/:certificateId", // 后台管理
            name: "systemManager",
            props: true,
            meta: {
                requiresAuth: true,
            },
            redirect: { name: "basicInfo" },
            // page/xSchool/56xSystemManager/home.vue
            component: () => import("page/xSchool/managerCom/mainWeb.vue"),
            children: [
                {
                    path: "basic",
                    name: "basicInfo",
                    props: true,
                    meta: {
                        userType: [utMSystem,utEJSystem],
                        requiresAuth: true,
                        title: "基本信息",
                    },
                    component: () => import("page/xSchool/56xSystemManager/basicInfo.vue"),
                },
                {
                    path: "news",
                    name: "newsManager",
                    props: true,
                    meta: {
                        userType: [utMSystem,utEJSystem],
                        requiresAuth: true,
                        title: "新闻",
                    },
                    component: () => import("page/xSchool/56xSystemManager/news.vue"),
                },
                {
                    path: "cooperate",
                    name: "cooperaEnter",
                    props: true,
                    meta: {
                        userType: [utMSystem,utEJSystem],
                        requiresAuth: true,
                        title: "合作企业",
                    },
                    component: () => import("page/xSchool/56xSystemManager/cooperaEnter.vue"),
                },
                {
                    path: "banner",
                    name: "bannerManager",
                    props: true,
                    meta: {
                        userType: [utMSystem,utEJSystem],
                        requiresAuth: true,
                        title: "横幅管理",
                    },
                    component: () => import("page/xSchool/56xSystemManager/bannerManager.vue"),
                },
                {
                    path: "bannerManger",
                    name: "bannerManger",
                    props: true,
                    meta: {
                        userType: [utMSystem,utEJSystem],
                        requiresAuth: true,
                        title: "精彩之窗",
                    },
                    component: () => import("page/xSchool/manager/BannerManger.vue"),
                },
                {
                    path: "MangerWord",
                    name: "MangerWord",
                    props: true,
                    meta: {
                        userType: [utMSystem,utEJSystem],
                        requiresAuth: true,
                        title: "管理文档",
                    },
                    component: () => import("page/xSchool/manager/MangerWord.vue"),
                },
                {
                    path: "ExamOutLine",
                    name: "ExamOutLine",
                    props: true,
                    meta: {
                        userType: [utMSystem,utEJSystem],
                        requiresAuth: true,
                        title: "考核大纲",
                    },
                    component: () => import("page/xSchool/manager/ExamOutLine.vue"),
                },
                {
                    path: "ProjectIntroduce",
                    name: "ProjectIntroduce",
                    props: true,
                    meta: {
                        userType: [utMSystem,utEJSystem],
                        requiresAuth: true,
                        title: "项目介绍",
                    },
                    component: () => import("page/xSchool/manager/ProjectIntroduce.vue"),
                },
                {
                    path: "StandardConstruction",
                    name: "StandardConstruction",
                    props: true,
                    meta: {
                        userType: [utMSystem,utEJSystem],
                        requiresAuth: true,
                        title: "标准建设",
                    },
                    component: () => import("page/xSchool/manager/StandardConstruction.vue"),
                },
                {
                    path: "user",
                    name: "userManager",
                    props: true,
                    meta: {
                        userType: [utMSystem,utEJSystem],
                        requiresAuth: true,
                        title: "用户管理",
                    },
                    component: () => import("page/xSchool/56xSystemManager/userManager.vue"),
                },
                {
                    path: "Xcertificate",
                    name: "XcertificateManager",
                    props: true,
                    meta: {
                        userType: [utMSystem,utEJSystem],
                        requiresAuth: true,
                        title: "证书类型管理",
                    },
                    component: () => import("page/xSchool/56xSystemManager/XcertificateManager.vue"),
                },
                {
                    path: "permissionMenu",
                    name: "permissionMenu",
                    props: true,
                    meta: {
                        userType: [utMSystem,utEJSystem],
                        requiresAuth: true,
                        title: "权限菜单管理",
                    },
                    component: () => import("page/xSchool/56xSystemManager/permissionMenu.vue"),
                },
                {
                    path: "permissionUser",
                    name: "permissionUser",
                    props: true,
                    meta: {
                        userType: [utMSystem,utEJSystem],
                        requiresAuth: true,
                        title: "权限用户管理",
                    },
                    component: () => import("page/xSchool/56xSystemManager/permissionUser.vue"),
                },
                {
                    path: "userMenu/:userId/:menuType",
                    name: "userMenu",
                    props: true,
                    meta: {
                        userType: [utMSystem,utEJSystem],
                        requiresAuth: true,
                        title: "权限用户菜单管理",
                    },
                    component: () => import("page/xSchool/56xSystemManager/userMenu.vue"),
                },
                // ---
                {
                    path: "pilot",
                    name: "pilotManager",
                    props: true,
                    meta: {
                        userType: [utMSystem,utEJSystem],
                        requiresAuth: true,
                        title: "试点申报管理",
                    },
                    component: () => import("page/xSchool/56xSystemManager/pilotManager.vue"),
                },
                {
                    path: "TeacherAppraiser",
                    name: "TeacherAppraiser",
                    props: true,
                    meta: {
                        userType: [utMSystem,utEJSystem],
                        requiresAuth: true,
                        title: "考评员审核",
                    },
                    component: () => import("page/xSchool/manager/TeacherAppraiser.vue"),
                },
                {
                    path: "teaBook",
                    name: "teaBookList",
                    props: true,
                    meta: {
                        userType: [utMSystem,utEJSystem],
                        requiresAuth: true,
                        title: "教材管理",
                    },
                    component: () => import("page/xSchool/teachingMaterial/teaBookList.vue"),
                },
                {
                    path: "teaBook/:courseId/:folderId/ShareManagement",
                    name: "ShareManagement",
                    props: true,
                    meta: {
                        userType: [utMSystem,utEJSystem],
                        requiresAuth: true,
                        title: "教材资源",
                    },
                    redirect: { name: "teaShareManagementSource" },
                    component: () => import("page/xSchool/teachingMaterial/teaManager/ShareManagement.vue"),
                    children: [
                        {
                            path: "teaShareManagementSource", // 课件
                            name: "teaShareManagementSource",
                            props: true,
                            meta: {
                                userType: [utMSystem,utEJSystem],
                                requiresAuth: true,
                                title: "课件",
                            },
                            component: () => import("page/xSchool/teachingMaterial/teaManager/ShareManagementSource.vue"),
                        },
                        {
                            path: "teaShareManagementHomework", // 作业
                            name: "teaShareManagementHomework",
                            props: true,
                            meta: {
                                title: "作业",
                            },
                            component: () => import("page/xSchool/teachingMaterial/teaManager/ShareManagementHomework.vue"),
                        },
                        {
                            path: "teaShareManagementQuestion", // 题库
                            name: "teaShareManagementQuestion",
                            props: true,
                            meta: {
                                title: "题库",
                            },
                            component: () => import("page/xSchool/teachingMaterial/ShareManagementQuestion.vue"),
                        },
                        {
                            path: ":knowledgeInfoId/teaSave", // 添加题目
                            name: "teaQuestionWarehouseAdd",
                            props: true,
                            meta: {
                                title: "添加题目",
                            },
                            component: () => import("page/xSchool/teachingMaterial/QuestionWarehouseAdd.vue"),
                        },
                        {
                            path: ":knowledgeInfoId/teaEdit", // 修改题目
                            name: "teaQuestionWarehouseedit",
                            props: true,
                            meta: {
                                title: "修改题目",
                            },
                            component: () => import("page/xSchool/teachingMaterial/QuestionWarehouseAdd.vue"),
                        },
                        {
                            path: "teaShareManagementCatalogue", // 目录
                            name: "teaShareManagementCatalogue",
                            props: true,
                            meta: {
                                title: "修改题目",
                            },
                            component: () => import("page/xSchool/teachingMaterial/teaManager/ShareManagementCatalogue.vue"),
                        },
                        {
                            path: "teaShareManagementattached", // 辅页
                            name: "teaShareManagementattached",
                            props: true,
                            meta: {
                                title: "辅页",
                            },
                            component: () => import("page/xSchool/teachingMaterial/teaManager/ShareManagementattached.vue"),
                        },
                        {
                            path: "teaShareManagementinteraction", // 互动
                            name: "teaShareManagementinteraction",
                            props: true,
                            meta: {
                                title: "互动",
                            },
                            component: () => import("page/xSchool/teachingMaterial/teaManager/ShareManagementinteraction.vue"),
                            children: [
                                {
                                    path: "teaShareDiscussCourse", // 分享互动--讨论
                                    name: "teaShareDiscussCourse",
                                    props: true,
                                    meta: {
                                        title: "讨论",
                                    },
                                    component: () => import("page/xSchool/teachingMaterial/teaManager/ShareManagementinteraction/ShareDiscussCourse.vue"),
                                },
                                {
                                    path: "teaShareVoteCourse", // 分享互动--投票
                                    name: "teaShareVoteCourse",
                                    props: true,
                                    meta: {
                                        title: "投票",
                                    },
                                    component: () => import("page/xSchool/teachingMaterial/teaManager/ShareManagementinteraction/ShareVoteCourse.vue"),
                                },
                                {
                                    path: "teaShareQuestion", // 分享互动--提问
                                    name: "teaShareQuestion",
                                    props: true,
                                    meta: {
                                        title: "提问",
                                    },
                                    component: () => import("page/xSchool/teachingMaterial/teaManager/ShareManagementinteraction/ShareQuestion.vue"),
                                },
                                {
                                    path: "teaShareTest", // 分享互动--测验
                                    name: "teaShareTest",
                                    props: true,
                                    meta: {
                                        title: "测验",
                                    },
                                    component: () => import("page/xSchool/teachingMaterial/teaManager/ShareManagementinteraction/ShareTest.vue"),
                                },
                                {
                                    path: "teaShareSurveyCourse", // 分享互动--问卷调查
                                    name: "teaShareSurveyCourse",
                                    props: true,
                                    meta: {
                                        title: "问卷调查",
                                    },
                                    component: () => import("page/xSchool/teachingMaterial/teaManager/ShareManagementinteraction/ShareSurveyCourse.vue"),
                                },
                                {
                                    path: "teaShareBrainstormingCourse", // 分享互动--头脑风暴
                                    name: "teaShareBrainstormingCourse",
                                    props: true,
                                    meta: {
                                        title: "头脑风暴",
                                    },
                                    component: () => import("page/xSchool/teachingMaterial/teaManager/ShareManagementinteraction/ShareBrainstormingCourse.vue"),
                                },
                                {
                                    path: "teaShareQuestionnaireQuestion/:questionnaireId", // 分享互动--添加问卷调查
                                    name: "teaShareQuestionnaireQuestion",
                                    props: true,
                                    meta: {
                                        title: "添加问卷调查",
                                    },
                                    component: () => import("page/xSchool/teachingMaterial/teaManager/ShareManagementinteraction/ShareQuestionnaireQuestion.vue"),
                                },
                            ],
                        },
                    ],
                },
                {
                    path: "/system/:courseId/:paperId/teaHomework_bank",
                    name: "teaHomework_bank",
                    props: true,
                    meta: {
                        title: "题库添加作业",
                    },
                    component: () => import("page/xSchool/teachingMaterial/Homework_bank.vue"),
                },
                {
                    path: "/system/:courseId/:paperId/teaEnclosureQuestion",
                    name: "teaEnclosureQuestion",
                    props: true,
                    meta: {
                        title: "题库添加附件作业",
                    },
                    component: () => import("page/xSchool/teachingMaterial/PaperEnclosureQuestion.vue"),
                },
                {
                    path: "/system/:courseId/:paperId/checkschoolehomework",
                    name: "checkschoolehomework",
                    props: true,
                    meta: {
                        title: "查看题库作业",
                    },
                    component: () => import("page/xSchool/teachingMaterial/Checkhomework.vue"),
                },
                {
                    path: "/system/:courseId/:paperId/checkschoolEnclosure",
                    name: "checkschoolEnclosure",
                    props: true,
                    meta: {
                        title: "查看附件作业",
                    },
                    component: () => import("page/xSchool/teachingMaterial/CheckEnclosure.vue"),
                },
                {
                    path: ":courseId/:questionnaireId/ShareSurveyCourseView", // 分享互动--问卷调查详情
                    name: "ShareSurveyCourseView",
                    props: true,
                    meta: {
                        title: "查看问卷调查",
                    },
                    component: () => import("page/xSchool/teachingMaterial/teaManager/ShareManagementinteraction/ShareSurveyCourseView.vue"),
                },
                {
                    path: "videoList", // 串讲视频
                    name: "videoList",
                    props: true,
                    meta: {
                        title: "串讲视频",
                    },
                    component: () => import("page/xSchool/56xSystemManager/videoList.vue"),
                },
                {
                    path: "webLink",
                    name: "webLink",
                    props: true,
                    meta: {
                        userType: [utMSystem,utEJSystem],
                        requiresAuth: true,
                        title: "网址配置",
                    },
                    component: () => import("page/xSchool/56xSystemManager/webLink.vue"),
                },
                {
                    path: "examDeclareManager",
                    name: "examDeclareManager",
                    props: true,
                    meta: {
                        userType: [utMSystem,utEJSystem],
                        requiresAuth: true,
                        title: "考试申报管理",
                    },
                    component: () => import("page/xSchool/56xSystemManager/examManager.vue"),
                },
                {
                    path: "examDeclareManager/examTime",
                    name: "examTime",
                    props: true,
                    meta: {
                        userType: [utMSystem,utEJSystem],
                        requiresAuth: true,
                        title: "考试批次管理",
                    },
                    component: () => import("page/xSchool/56xSystemManager/ExamTime.vue"),
                },
                {
                    path: "FileManager",
                    name: "FileManager",
                    props: true,
                    meta: {
                        userType: [utMSystem,utEJSystem],
                        requiresAuth: true,
                        title: "考试端地址",
                    },
                    component: () => import("page/xSchool/56xSystemManager/uploadFileManager.vue"),
                },
                {
                    path: "examInfoManager",
                    name: "examInfoManager",
                    props: true,
                    meta: {
                        userType: [utMSystem,utEJSystem],
                        requiresAuth: true,
                        title: "考试信息管理",
                    },
                    component: () => import("page/xSchool/56xSystemManager/examInfoManager.vue"),
                },
                {
                    path: "adoptSchool",
                    name: "adoptSchool",
                    props: true,
                    meta: {
                        userType: [utMSystem,utEJSystem],
                        requiresAuth: true,
                        title: "站点管理",
                    },
                    component: () => import("page/xSchool/manager/siteManager/adoptSchool.vue"),
                },
                {
                    path: "assessmentApply",
                    name: "assessmentApply",
                    props: true,
                    meta: {
                        userType: [utMSystem,utEJSystem],
                        requiresAuth: true,
                        title: "考核站点申请",
                    },
                    component: () => import("page/xSchool/manager/siteManager/assessmentApply.vue"),
                },
                {
                    path: "provincialHead",
                    name: "provincialHead",
                    props: true,
                    meta: {
                        userType: [utMSystem,utEJSystem],
                        requiresAuth: true,
                        title: "省级工作室",
                    },
                    component: () => import("page/xSchool/manager/siteManager/provincialHead.vue"),
                },

                {
                    path: "statistical",
                    name: "statistical",
                    props: true,
                    meta: {
                        userType: [utMSystem,utEJSystem],
                        requiresAuth: true,
                        title: "毕业生就业统计",
                    },
                    component: () => import("page/xSchool/manager/siteManager/statistical.vue"),
                },
                {
                    path: "jobsNeed",
                    name: "jobsNeed",
                    props: true,
                    meta: {
                        userType: [utMSystem,utEJSystem],
                        requiresAuth: true,
                        title: "招聘岗位信息",
                    },
                    component: () => import("page/xSchool/manager/siteManager/jobsNeed.vue"),
                },
                {
                    path: "candidate",
                    name: "candidate",
                    props: true,
                    meta: {
                        userType: [utMSystem,utEJSystem],
                        requiresAuth: true,
                        title: "物流教指委信息",
                    },
                    component: () => import("page/xSchool/manager/siteManager/candidate.vue"),
                },
                {
                    path: "resultsManager",
                    name: "resultsManager",
                    props: true,
                    meta: {
                        userType: [utMSystem,utEJSystem],
                        requiresAuth: true,
                        title: "学生成绩管理",
                    },
                    component: () => import("page/xSchool/56xSystemManager/resultsManager.vue"),
                },
                {
                    path: "certificateManager",
                    name: "certificateManager",
                    props: true,
                    meta: {
                        userType: [utMSystem,utEJSystem],
                        requiresAuth: true,
                        title: "证书管理",
                    },
                    component: () => import("page/xSchool/56xSystemManager/certificateManager.vue"),
                },
                {
                    path: "certificateManagerTea",
                    name: "certificateManagerTea",
                    props: true,
                    meta: {
                        userType: [utMSystem,utEJSystem],
                        requiresAuth: true,
                        title: "师资证书管理",
                    },
                    component: () => import("page/xSchool/56xSystemManager/certificateManagerTea.vue"),
                },
                {
                    path: "certificateTypeManager",
                    name: "certificateTypeManager",
                    props: true,
                    meta: {
                        userType: [utMSystem,utEJSystem],
                        requiresAuth: true,
                        title: "证书类型设置",
                    },
                    component: () => import("page/xSchool/56xSystemManager/certificateTypeManager.vue"),
                },
                {
                    path: "certificateTypeConfigManager",
                    name: "certificateTypeConfigManager",
                    props: true,
                    meta: {
                        userType: [utMSystem,utEJSystem],
                        requiresAuth: true,
                        title: "证书大类设置",
                    },
                    component: () => import("page/xSchool/56xSystemManager/certificateTypeConfigManager.vue"),
                },
                {
                    path: "site",
                    name: "sysSiteManager",
                    props: true,
                    redirect: { name: "certifyStadard" },
                    meta: {
                        userType: [utMSystem,utEJSystem],
                        requiresAuth: true,
                        title: "站点管理",
                    },
                    component: () => import("page/xSchool/56xSystemManager/site.vue"),
                    children: [
                        {
                            path: "siteManager",
                            name: "siteManagement",
                            props: true,
                            meta: {
                                userType: [utMSystem,utEJSystem],
                                requiresAuth: true,
                                title: "站点管理",
                            },
                            component: () => import("page/xSchool/manager/SiteManagement.vue"),
                        },
                        {
                            path: "authenti",
                            name: "siteAuthentication",
                            props: true,
                            meta: {
                                userType: [utMSystem,utEJSystem],
                                requiresAuth: true,
                                title: "站点认证",
                            },
                            component: () => import("page/xSchool/manager/SiteAuthentication.vue"),
                        },
                        {
                            path: "siteActive",
                            name: "siteActivity",
                            props: true,
                            meta: {
                                userType: [utMSystem,utEJSystem],
                                requiresAuth: true,
                                title: "站点活动",
                            },
                            component: () => import("page/xSchool/manager/SiteActivity.vue"),
                        },
                        {
                            path: "certify",
                            name: "certifyStadard",
                            props: true,
                            meta: {
                                userType: [utMSystem,utEJSystem],
                                requiresAuth: true,
                                title: "认证标准",
                            },
                            component: () => import("page/xSchool/manager/certifyStadard.vue"),
                        },
                        {
                            path: "certify/:certifiId/authenNode",
                            name: "authenticationNode",
                            props: true,
                            meta: {
                                userType: [utMSystem,utEJSystem],
                                requiresAuth: true,
                                title: "认证节点",
                            },
                            component: () => import("page/xSchool/manager/AuthenticationNode.vue"),
                        },
                    ],
                },
                {
                    path: "stu",
                    name: "sysStuManager",
                    props: true,
                    redirect: { name: "AuthenStandard" },
                    meta: {
                        userType: [utMSystem,utEJSystem],
                        requiresAuth: true,
                        title: "学员管理",
                    },
                    component: () => import("page/xSchool/56xSystemManager/stuManager.vue"),
                    children: [
                        {
                            path: "infoTest",
                            name: "siteInfoTest",
                            props: true,
                            meta: {
                                userType: [utMSystem,utEJSystem],
                                requiresAuth: true,
                                title: "站点考试信息审核",
                            },
                            component: () => import("page/xSchool/manager/StuTestAudit.vue"),
                        },
                        {
                            path: "trainCheck",
                            name: "siteTrainCheck",
                            props: true,
                            meta: {
                                userType: [utMSystem,utEJSystem],
                                requiresAuth: true,
                                title: "站点培训信息审核",
                            },
                            component: () => import("page/xSchool/manager/StuTrainAudit.vue"),
                        },
                        {
                            path: "stuExamCheck",
                            name: "stuExamCheck",
                            props: true,
                            meta: {
                                userType: [utMSystem,utEJSystem],
                                requiresAuth: true,
                                title: "学员考证审核",
                            },
                            component: () => import("page/xSchool/manager/SudentAudit.vue"),
                        },
                        {
                            path: "standard",
                            name: "AuthenStandard",
                            props: true,
                            meta: {
                                userType: [utMSystem,utEJSystem],
                                requiresAuth: true,
                                title: "认证标准",
                            },
                            component: () => import("page/xSchool/manager/siteCertifyStadard.vue"),
                        },
                        {
                            path: "standard/:certifiId/node",
                            name: "AuthenNode",
                            props: true,
                            meta: {
                                userType: [utMSystem,utEJSystem],
                                requiresAuth: true,
                                title: "认证节点",
                            },
                            component: () => import("page/xSchool/manager/siteAuthenticationNode.vue"),
                        },
                    ],
                },
                // {
                //   path: 'exammanage',
                //   name: 'exammanage',
                //   props: true,
                //   meta: {
                //     userType: [utMSystem,utEJSystem],
                //     requiresAuth: true,
                //     title: '1+X考试管理',
                //   },
                //   redirect: {name: 'examManager'},
                //   component: () =>
                //     import ('page/xSchool/56xSystemManager/exammanage.vue'),
                //   children: [
                //     // {
                //     //   path: 'examManager',
                //     //   name: 'examManager',
                //     //   props: true,
                //     //   meta: {
                //     //     userType: [utMSystem,utEJSystem],
                //     //     requiresAuth: true,
                //     //     title: '考试申报管理',
                //     //   },
                //     //   component: () =>
                //     //     import ('page/xSchool/56xSystemManager/examManager.vue'),
                //     // },
                //     // {
                //     //   path: 'resultsManager',
                //     //   name: 'resultsManager',
                //     //   props: true,
                //     //   meta: {
                //     //     userType: [utMSystem,utEJSystem],
                //     //     requiresAuth: true,
                //     //     title: '学生成绩管理',
                //     //   },
                //     //   component: () =>
                //     //     import ('page/xSchool/56xSystemManager/resultsManager.vue'),
                //     // },
                //     // {
                //     //   path: 'certificateManager',
                //     //   name: 'certificateManager',
                //     //   props: true,
                //     //   meta: {
                //     //     userType: [utMSystem,utEJSystem],
                //     //     requiresAuth: true,
                //     //     title: '证书管理',
                //     //   },
                //     //   component: () =>
                //     //     import ('page/xSchool/56xSystemManager/certificateManager.vue'),
                //     // },
                //     // {
                //     //   path: 'certificateTypeManager',
                //     //   name: 'certificateTypeManager',
                //     //   props: true,
                //     //   meta: {
                //     //     userType: [utMSystem,utEJSystem],
                //     //     requiresAuth: true,
                //     //     title: '证书类型设置',
                //     //   },
                //     //   component: () =>
                //     //     import (
                //     //       'page/xSchool/56xSystemManager/certificateTypeManager.vue'
                //     //     ),
                //     // },
                //   ],
                // },
                // {
                //   path: 'pilot',
                //   name: 'pilotManager',
                //   props: true,
                //   meta: {
                //     userType: [utMSystem,utEJSystem],
                //     requiresAuth: true,
                //     title: '试点申报管理',
                //   },
                //   component: () =>
                //     import ('page/xSchool/56xSystemManager/pilotManager.vue'),
                // },
                {
                    path: "committee",
                    name: "committee",
                    props: true,
                    meta: {
                        userType: [utMSystem,utEJSystem],
                        requiresAuth: true,
                        title: "委员会委员管理",
                    },
                    component: () => import("page/xSchool/56xSystemManager/committeeManager.vue"),
                },
                // {
                //   path: 'examTime',
                //   name: 'examTime',
                //   props: true,
                //   meta: {
                //     userType: [utMSystem,utEJSystem],
                //     requiresAuth: true,
                //     title: '考试批次管理',
                //   },
                //   component: () =>
                //     import ('page/xSchool/56xSystemManager/ExamTime.vue'),
                // },
                {
                    path: "activity",
                    name: "activityManager",
                    props: true,
                    redirect: { name: "MeetingManager" },
                    meta: {
                        userType: [utMSystem,utEJSystem],
                        requiresAuth: true,
                        title: "活动管理",
                    },
                    component: () => import("page/xSchool/56xSystemManager/activity.vue"),
                    children: [
                        {
                            path: "MeetingManager",
                            name: "MeetingManager",
                            props: true,
                            meta: {
                                userType: [utMSystem,utEJSystem],
                                requiresAuth: true,
                                title: "会议报名",
                            },
                            component: () => import("page/xSchool/manager/MeetingManager.vue"),
                        },
                        {
                            path: "PeiXunManager",
                            name: "PeiXunManager",
                            props: true,
                            meta: {
                                userType: [utMSystem,utEJSystem],
                                requiresAuth: true,
                                title: "培训报名",
                            },
                            component: () => import("page/xSchool/manager/PeiXunManager.vue"),
                        },
                        {
                            path: "KaoHeManager",
                            name: "KaoHeManager",
                            props: true,
                            meta: {
                                userType: [utMSystem,utEJSystem],
                                requiresAuth: true,
                                title: "培训报名",
                            },
                            component: () => import("page/xSchool/manager/KaoHeManager.vue"),
                        },
                        {
                            path: ":activityId/MeetingEnrollManager",
                            name: "MeetingEnrollManager",
                            props: true,
                            meta: {
                                userType: [utMSystem,utEJSystem],
                                requiresAuth: true,
                                title: "会议报名",
                            },
                            component: () => import("page/xSchool/manager/MeetingEnrollManager.vue"),
                        },
                        {
                            path: ":activityId/PeiXunEnrollManager",
                            name: "PeiXunEnrollManager",
                            props: true,
                            meta: {
                                userType: [utMSystem,utEJSystem],
                                requiresAuth: true,
                                title: "培训报名",
                            },
                            component: () => import("page/xSchool/manager/PeiXunEnrollManager.vue"),
                        },
                        {
                            path: ":activityId/HotelManager",
                            name: "HotelManager",
                            props: true,
                            meta: {
                                userType: [utMSystem,utEJSystem],
                                requiresAuth: true,
                                title: "会议酒店管理",
                            },
                            component: () => import("page/xSchool/manager/HotelManager.vue"),
                        },
                        {
                            path: ":activityId/PeiXunPlanManager",
                            name: "PeiXunPlanManager",
                            props: true,
                            meta: {
                                userType: [utMSystem,utEJSystem],
                                requiresAuth: true,
                                title: "培训轮次管理",
                            },
                            component: () => import("page/xSchool/manager/PeiXunPlanManager.vue"),
                        },
                    ],
                },
                {
                    path: "/setUpTeacher/:siteId",
                    name: "setUpTeacher",
                    props: true,
                    meta: {
                        userType: [utMSystem,utEJSystem],
                        requiresAuth: true,
                        title: "设置讲师",
                    },
                    component: () => import("page/xSchool/manager/siteManager/setUpTeacher.vue"),
                },
                {
                    path: "/setUpCommentator/:siteId",
                    name: "setUpCommentator",
                    props: true,
                    meta: {
                        userType: [utMSystem,utEJSystem],
                        requiresAuth: true,
                        title: "设置考评员",
                    },
                    component: () => import("page/xSchool/manager/siteManager/setUpCommentator.vue"),
                },
                {
                    path: "siteManager",
                    name: "siteManager",
                    redirect: { name: "adoptSchool" },
                    props: true,
                    meta: {
                        userType: [utMSystem,utEJSystem],
                        requiresAuth: true,
                        title: "试点学校",
                    },
                    component: () => import("page/xSchool/56xSystemManager/siteManager.vue"),
                    children: [
                        // {
                        //   path: 'adoptSchool',
                        //   name: 'adoptSchool',
                        //   props: true,
                        //   meta: {
                        //     userType: [utMSystem,utEJSystem],
                        //     requiresAuth: true,
                        //     title: '站点管理',
                        //   },
                        //   component: () =>
                        //     import ('page/xSchool/manager/siteManager/adoptSchool.vue'),
                        // },
                        {
                            path: "adoptSchoolManager/:schoolId",
                            name: "adoptSchoolManager",
                            props: true,
                            meta: {
                                userType: [utMSystem,utEJSystem],
                                requiresAuth: true,
                                title: "学员考证审核",
                            },
                            component: () => import("page/xSchool/manager/siteManager/adoptSchoolManager.vue"),
                        },
                        // {
                        //   path: 'provincialHead',
                        //   name: 'provincialHead',
                        //   props: true,
                        //   meta: {
                        //     userType: [utMSystem,utEJSystem],
                        //     requiresAuth: true,
                        //     title: '省级工作室',
                        //   },
                        //   component: () =>
                        //     import ('page/xSchool/manager/siteManager/provincialHead.vue'),
                        // },
                        // {
                        //   path: 'assessmentApply',
                        //   name: 'assessmentApply',
                        //   props: true,
                        //   meta: {
                        //     userType: [utMSystem,utEJSystem],
                        //     requiresAuth: true,
                        //     title: '考核站点申请',
                        //   },
                        //   component: () =>
                        //     import ('page/xSchool/manager/siteManager/assessmentApply.vue'),
                        // },
                    ],
                },
                // {
                //     path: 'special',
                //     name: 'specialManager',
                //     props: true,
                //     redirect: { name: 'MeetingManager' },
                //     meta: {
                //         userType: [utMSystem,utEJSystem],
                //         requiresAuth: true,
                //         title: '专题活动管理'
                //     },
                //     component: () =>
                //         import ('page/xSchool/56xSystemManager/special.vue'),
                //     children: [{
                //             path: 'MeetingManager',
                //             name: 'MeetingManager',
                //             props: true,
                //             meta: {
                //                 userType: [utMSystem,utEJSystem],
                //                 requiresAuth: true,
                //                 title: '会议报名'
                //             },
                //             component: () =>
                //                 import ('page/xSchool/manager/MeetingManager.vue'),
                //         },
                //         {
                //             path: ':activityId/MeetingEnrollManager',
                //             name: 'MeetingEnrollManager',
                //             props: true,
                //             meta: {
                //                 userType: [utMSystem,utEJSystem],
                //                 requiresAuth: true,
                //                 title: '会议报名'
                //             },
                //             component: () =>
                //                 import ('page/xSchool/manager/MeetingEnrollManager.vue'),
                //         },
                //         {
                //             path: 'OtherManager',
                //             name: 'OtherManager',
                //             props: true,
                //             meta: {
                //                 userType: [utMSystem,utEJSystem],
                //                 requiresAuth: true,
                //                 title: '其他活动'
                //             },
                //             component: () =>
                //                 import ('page/xSchool/manager/OtherManager.vue'),
                //         }
                //     ]
                // },
                {
                    path: "sourseManager",
                    name: "sourseManager",
                    props: true,
                    redirect: { name: "studyMaterial" },
                    component: () => import("page/xSchool/56xStuManager/sourseManager.vue"),
                    meta: {
                        userType: [utMSystem,utEJSystem],
                        requiresAuth: true,
                        title: "资料管理",
                    },
                    children: [
                        {
                            path: "material",
                            name: "studyMaterial",
                            props: true,
                            meta: {
                                userType: [utMSystem,utEJSystem],
                                requiresAuth: true,
                                title: "学习资料",
                            },
                            component: () => import("page/xSchool/manager/LearningMaterials.vue"),
                        },
                        {
                            path: "sourceMaterial",
                            name: "sourceMaterial",
                            props: true,
                            meta: {
                                userType: [utMSystem,utEJSystem],
                                requiresAuth: true,
                                title: "章节素材管理",
                            },
                            component: () => import("page/xSchool/manager/ChapterMaterialManage.vue"),
                        },
                        {
                            path: "stu/upload/:learnId",
                            name: "stuUpload",
                            props: true,
                            meta: {
                                userType: [utMSystem,utEJSystem],
                                requiresAuth: true,
                                title: "学员管理上传",
                            },
                            component: () => import("page/xSchool/manager/LearningUpload.vue"),
                        },
                    ],
                },
                // 学员后台管理
                {
                    path: "stuBasic",
                    name: "stuBasicInfo",
                    props: true,
                    meta: {
                        userType: [utStudent],
                        requiresAuth: true,
                        title: "学员基本信息",
                    },
                    component: () => import("page/xSchool/56xStuManager/stuBasic.vue"),
                },
                {
                    path: "stuPaperCertApply",
                    name: "stuPaperCertApply",
                    props: true,
                    meta: {
                        userType: [utStudent],
                        requiresAuth: true,
                        title: "纸质证书申请",
                    },
                    component: () => import("page/xSchool/56xStuManager/stuPaperCertApply.vue"),
                },
                {
                    path: "myCertificate",
                    name: "myCertificate",
                    props: true,
                    meta: {
                        userType: [utStudent],
                        requiresAuth: true,
                        title: "我的证书",
                    },
                    component: () => import("page/xSchool/56xStuManager/myCertificate.vue"),
                },
                {
                    path: "testResearch",
                    name: "testResearch",
                    props: true,
                    meta: {
                        userType: [utStudent],
                        requiresAuth: true,
                        title: "学员考证",
                    },
                    component: () => import("page/xSchool/56xStuManager/textualResearch.vue"),
                },
                {
                    path: "stuTrain",
                    name: "stuTrain",
                    props: true,
                    meta: {
                        userType: [utStudent],
                        requiresAuth: true,
                        title: "学员培训",
                    },
                    component: () => import("page/xSchool/56xStuManager/stuTrain.vue"),
                },
                // 讲师后台
                {
                    path: "teaBasic",
                    name: "teaBasicInfo",
                    props: true,
                    meta: {
                        userType: [utTeacher],
                        requiresAuth: true,
                        title: "讲师基本信息",
                    },
                    component: () => import("page/xSchool/teaManager/teaIndexBasicInfo.vue"),
                },
                {
                    path: "cerSignature",
                    name: "cerSignatureUpload",
                    props: true,
                    meta: {
                        userType: [utTeacher],
                        requiresAuth: true,
                        title: "证书签名上传",
                    },
                    component: () => import("page/xSchool/56xSystemManager/cerSignatureUpload.vue"),
                },
                {
                    path: "teaMyCerfity",
                    name: "teaMyCerfity",
                    props: true,
                    meta: {
                        userType: [utTeacher],
                        requiresAuth: true,
                        title: "我的证书",
                    },
                    component: () => import("page/xSchool/teaManager/teaCertificate.vue"),
                },
                {
                    path: "teaApply",
                    name: "teaApplyLecture",
                    props: true,
                    meta: {
                        // userType: [utTeacher],
                        // requiresAuth: true,
                        title: "申请认证讲师",
                    },
                    component: () => import("page/xSchool/teaManager/applyLecturer.vue"),
                },
                {
                    path: "teaTrain",
                    name: "teaTrain",
                    props: true,
                    meta: {
                        userType: [utTeacher],
                        requiresAuth: true,
                        title: "讲师培训报名",
                    },
                    component: () => import("page/xSchool/teaManager/teacherTraining.vue"),
                },
                {
                    path: "teaPilotManager",
                    name: "teaPilotManager",
                    props: true,
                    meta: {
                        userType: [utTeacher],
                        requiresAuth: true,
                        title: "试点申报管理",
                    },
                    component: () => import("page/xSchool/teaManager/teaPilotManager.vue"),
                },
                {
                    path: "teaActivity",
                    name: "teaActivity",
                    props: true,
                    redirect: { name: "EnrollManager" },
                    meta: {
                        userType: [utTeacher],
                        requiresAuth: true,
                        title: "活动管理",
                    },
                    component: () => import("page/xSchool/teaManager/teaActivity.vue"),
                    children: [
                        {
                            path: "EnrollManager",
                            name: "EnrollManager",
                            props: true,
                            meta: {
                                userType: [utTeacher],
                                requiresAuth: true,
                                title: "会议报名管理",
                            },
                            component: () => import("page/xSchool/teaManager/EnrollManager.vue"),
                        },
                        {
                            path: "PeiXunEnrollManager",
                            name: "TeaPeiXunEnrollManager",
                            props: true,
                            meta: {
                                userType: [utTeacher],
                                requiresAuth: true,
                                title: "培训报名管理",
                            },
                            component: () => import("page/xSchool/teaManager/PeiXunEnrollManager.vue"),
                        },
                    ],
                },
                {
                    path: "TrainApplyManager",
                    name: "TrainApplyManager",
                    props: true,
                    meta: {
                        userType: [utTeacher],
                        requiresAuth: true,
                        title: "试点申报管理",
                    },
                    component: () => import("page/xSchool/teaManager/TrainApplyManager.vue"),
                },
                {
                    path: "assessmentApplyTea",
                    name: "assessmentApplyTea",
                    props: true,
                    meta: {
                        userType: [utTeacher],
                        requiresAuth: true,
                        title: "试点申报管理",
                    },
                    component: () => import("page/xSchool/teaManager/assessmentApply.vue"),
                },
                {
                    path: "committeeManager",
                    name: "committeeManager",
                    props: true,
                    meta: {
                        userType: [utTeacher],
                        requiresAuth: true,
                        title: "委员会委员申报管理",
                    },
                    component: () => import("page/xSchool/teaManager/committeeManager.vue"),
                },
                {
                    path: "examDeclare",
                    name: "examDeclare",
                    props: true,
                    meta: {
                        userType: [utTeacher],
                        requiresAuth: true,
                        title: "考试申报管理",
                    },
                    component: () => import("page/xSchool/teaManager/examDeclareManager.vue"),
                },
                // 站点后台
                {
                    path: "siteBasic",
                    name: "siteBasicInfo",
                    props: true,
                    meta: {
                        userType: [utMSite, utTeacher],
                        requiresAuth: true,
                        title: "站点基本信息",
                    },
                    component: () => import("page/xSchool/siteManager/siteInfoIndex.vue"),
                },
                {
                    path: "siteteaManager",
                    name: "siteteaManager",
                    props: true,
                    meta: {
                        userType: [utMSite, utTeacher],
                        requiresAuth: true,
                        title: "站点讲师管理",
                    },
                    component: () => import("page/xSchool/siteManager/lecturerManager.vue"),
                },
                {
                    path: "siteTrain",
                    name: "siteTrainManager",
                    props: true,
                    meta: {
                        userType: [utMSite, utTeacher],
                        requiresAuth: true,
                        title: "站点培训管理",
                    },
                    component: () => import("page/xSchool/siteManager/peiXunManager.vue"),
                },
                {
                    path: "siteTrain/:attestationId",
                    name: "siteTrainDetail",
                    props: true,
                    meta: {
                        userType: [utMSite, utTeacher],
                        requiresAuth: true,
                        title: "培训详情",
                    },
                    component: () => import("page/xSchool/siteManager/trainDetail.vue"),
                },
                {
                    path: "siteTest",
                    name: "siteTestManager",
                    props: true,
                    meta: {
                        userType: [utMSite, utTeacher],
                        requiresAuth: true,
                        title: "站点考试管理",
                    },
                    component: () => import("page/xSchool/siteManager/kaoZhengManager.vue"),
                },
                {
                    path: "siteTest/:attestationId",
                    name: "siteTestDetail",
                    props: true,
                    meta: {
                        userType: [utMSite, utTeacher],
                        requiresAuth: true,
                        title: "报考详情",
                    },
                    component: () => import("page/xSchool/siteManager/testDetail.vue"),
                },
                // ITC换证
                {
                    path: "itcBatchManager",
                    name: "itcBatchManager",
                    props: true,
                    meta: {
                        userType: [utMSystem,utEJSystem],
                        requiresAuth: true,
                        title: "ITC换证批次管理",
                    },
                    component: () => import("page/xSchool/ITC/itcBatchManager.vue"),
                },
                {
                    path: "itcPaperManager",
                    name: "itcPaperManager",
                    props: true,
                    meta: {
                        userType: [utMSystem,utEJSystem],
                        requiresAuth: true,
                        title: "ITC换证批次管理",
                    },
                    component: () => import("page/xSchool/ITC/itcPaperManager.vue"),
                },
                {
                    path: "itcSiteManager",
                    name: "itcSiteManager",
                    props: true,
                    meta: {
                        userType: [utMSystem,utEJSystem],
                        requiresAuth: true,
                        title: "ITC换证申请管理",
                    },
                    component: () => import("page/xSchool/ITC/itcSiteManager.vue"),
                },
                {
                    path: "itcManager/:schoolId?",
                    name: "itcManager",
                    props: true,
                    meta: {
                        userType: [utMSystem,utEJSystem],
                        requiresAuth: true,
                        title: "ITC换证申请管理",
                    },
                    component: () => import("page/xSchool/ITC/applyManager.vue"),
                },
                {
                    path: 'projectManager',
                    name: 'projectManager',
                    props: true,
                    component: () => import("page/custom/projectManager.vue"),
                    meta: {
                        userType: [utMSystem,utEJSystem],
                        requiresAuth: true,
                        title: "项目管理",
                    },
                },
                {
                    path: 'projectModelManager',
                    name: 'projectModelManager',
                    props: true,
                    component: () => import("page/custom/projectModelManager.vue"),
                    meta: {
                        userType: [utMSystem,utEJSystem],
                        requiresAuth: true,
                        title: "项目模板管理",
                    },
                },
                {
                    path: 'customForm/:projectId',
                    name: 'customForm',
                    props: true,
                    component: () => import("page/custom/customForm.vue"),
                    meta: {
                        userType: [utMSystem,utEJSystem],
                        requiresAuth: true,
                        title: "自定义表单生成",
                    },
                },
                {
                    path: 'projectApplyManager/:projectId',
                    name: 'projectApplyManager',
                    props: true,
                    component: () => import("page/custom/projectApplyManager.vue"),
                    meta: {
                        userType: [utMSystem,utEJSystem],
                        requiresAuth: true,
                        title: "项目申请",
                    },
                }
            ],
        },
        {
            path: "/wlx/itcIndex",
            name: "itcIndex",
            props: true,
            component: () => import("page/xSchool/ITC/itcIndex.vue"),
            redirect: { name: "assessApplyTea" },
            children: [
                {
                    path: "assessApplyTea",
                    name: "assessApplyTea",
                    props: true,
                    meta: {
                        userType: [utMSchool],
                        requiresAuth: true,
                        title: "试点申报管理",
                    },
                    component: () => import("page/xSchool/teaManager/assessmentApply.vue"),
                },
                {
                    path: "itcBatch",
                    name: "itcBatch",
                    props: true,
                    meta: {
                        userType: [utMSchool],
                        requiresAuth: true,
                        title: "ITC换证批次",
                    },
                    component: () => import("page/xSchool/ITC/itcBatchList.vue"),
                },
                {
                    path: "applyITC/:batchId?",
                    name: "applyITC",
                    props: true,
                    meta: {
                        userType: [utMSchool],
                        requiresAuth: true,
                        title: "ITC换证申请",
                    },
                    component: () => import("page/xSchool/ITC/applyList.vue"),
                },
                {
                    path: "projectList",
                    name: "projectList",
                    props: true,
                    meta: {
                        userType: [utMSchool],
                        requiresAuth: true,
                        title: "项目申请",
                    },
                    component: () => import("page/xSchool/ITC/projectList.vue"),
                },
                {
                    path: "projectApplyList/:projectId?",
                    name: "projectApplyList",
                    props: true,
                    meta: {
                        userType: [utMSchool],
                        requiresAuth: true,
                        title: "项目申请明细",
                    },
                    component: () => import("page/xSchool/ITC/projectApplyList.vue"),
                },
            ]
        },
        {
            path: "/wlx/siteHome/:state/:schoolManagerId",
            name: "siteHome",
            props: true,
            meta: {
                title: "培训站点管理",
            },
            redirect: { name: "trainSiteInfo" },
            component: () => import("page/xSchool/56xSystemManager/siteHome.vue"),
            children: [
                {
                    path: "trainSiteInfo",
                    name: "trainSiteInfo",
                    props: true,
                    meta: {
                        userType: [utMSite, utTeacher],
                        requiresAuth: true,
                        title: "站点基本信息管理",
                    },
                    component: () => import("page/xSchool/siteManager/trainSiteInfo.vue"),
                },
                {
                    path: "tarinActivity",
                    name: "tarinActivity",
                    props: true,
                    meta: {
                        userType: [utMSite, utTeacher],
                        requiresAuth: true,
                        title: "培训活动管理",
                    },
                    component: () => import("page/xSchool/siteManager/tarinActivity.vue"),
                },
                {
                    path: "lookTarinTea",
                    name: "lookTarinTea",
                    props: true,
                    meta: {
                        userType: [utMSite, utTeacher],
                        requiresAuth: true,
                        title: "查看活动讲师",
                    },
                    component: () => import("page/xSchool/siteManager/lookTarinTea.vue"),
                },
                {
                    path: ":activityId/activeManager",
                    name: "activeManager",
                    props: true,
                    meta: {
                        userType: [utMSite, utTeacher],
                        requiresAuth: true,
                        title: "培训报名",
                    },
                    component: () => import("page/xSchool/siteManager/activeManager.vue"),
                },
                {
                    path: ":activityId/activeNumberManager",
                    name: "activeNumberManager",
                    props: true,
                    meta: {
                        userType: [utMSite, utTeacher],
                        requiresAuth: true,
                        title: "培训轮次管理",
                    },
                    component: () => import("page/xSchool/siteManager/activeNumberManager.vue"),
                },
                {
                    path: "assessSiteManager",
                    name: "assessSiteManager",
                    props: true,
                    meta: {
                        userType: [utMSite, utTeacher],
                        requiresAuth: true,
                        title: "考核站点管理",
                    },
                    component: () => import("page/xSchool/siteManager/assessSiteManager.vue"),
                },
                {
                    path: "examinerInfo",
                    name: "examinerInfo",
                    props: true,
                    meta: {
                        userType: [utMSite, utTeacher],
                        requiresAuth: true,
                        title: "考核站点管理",
                    },
                    component: () => import("page/xSchool/siteManager/examinerInfo.vue"),
                },
            ],
        },
        {
            path: "/wlx/diaocha",
            name: "basicStatistics",
            props: true,
            meta: {
                title: "基本情况统计",
            },
            component: () => import("page/xSchool/basicStatistics.vue"),
        },
        {
            path: "/wlx/:id/declareSite",
            name: "declareSite",
            props: true,
            meta: {
                title: "管理员试点申报管理",
            },
            component: () => import("page/xSchool/declareSite.vue"),
        },
        {
            path: "/wlx/:id/teaTestDeclare",
            name: "teaTestDeclare",
            props: true,
            meta: {
                title: "老师试点申报详情",
            },
            component: () => import("page/xSchool/teaTestDeclareManage.vue"),
        },
        {
            path: "/password/:source?",
            name: "password",
            props: true,
            component: () => import("page/xSchool/retrievePassword.vue"),
            meta: {
                title: "找回密码",
            },
        },
        {
            path: "/teaApply/:certificateId",
            name: "teaApply",
            props: true,
            meta: {
                userType: [utTeacher],
                requiresAuth: true,
                title: "教师后台管理",
            },
            component: () => import("page/xSchool/teaBackManager.vue"),
        },
        {
            path: "/applyTable/:userType/:certificateId",
            name: "applyTable",
            props: true,
            meta: {
                userType: [utTeacher],
                requiresAuth: true,
                title: "认证申请表",
            },
            component: () => import("page/xSchool/applyTable.vue"),
        },
        {
            path: "/examSingUp/:certificateId",
            name: "examSingUp",
            props: true,
            meta: {
                userType: [utTeacher],
                requiresAuth: true,
                title: "考试申请表",
            },
            component: () => import("page/xSchool/examSingUp.vue"),
        },
        {
            path: "/examSingUpPrive/:examId",
            name: "examSingUpPrive",
            props: true,
            meta: {
                userType: [utMSystem,utEJSystem],
                requiresAuth: true,
                title: "查看考试申请表",
            },
            component: () => import("page/xSchool/examSingUpPrive.vue"),
        },
        {
            path: "/examSingUpPriveEdit/:examId",
            name: "examSingUpPriveEdit",
            props: true,
            meta: {
                // userType: [utMSite],
                requiresAuth: true,
                title: "编辑考试申请表",
            },
            component: () => import("page/xSchool/examSingUpPriveEdit.vue"),
        },

        {
            path: "/applyTableEdit/:userId/:userType/:url/:pageSize/:pageIndex",
            name: "applyTableEdit",
            props: true,
            meta: {
                title: "认证申请表编辑",
                requiresAuth: true,
            },
            component: () => import("page/xSchool/applyTableEdit.vue"),
        },
        {
            path: "/applyTableDetail/:userId/:userType",
            name: "applyTableDetail",
            props: true,
            meta: {
                title: "认证申请表详情",
                requiresAuth: true,
            },
            component: () => import("page/xSchool/applyTableDetail.vue"),
        },
        {
            path: "/signTable/:signUpId",
            name: "signUpTable",
            props: true,
            meta: {
                title: "报名回执表",
            },
            component: () => import("page/xSchool/receiptTable.vue"),
        },
        {
            path: "/signTableEdit/:signUpId",
            name: "signTableEdit",
            props: true,
            meta: {
                userType: [utTeacher],
                requiresAuth: true,
                title: "报名回执表",
            },
            component: () => import("page/xSchool/receiptTableEdit.vue"),
        },
        {
            path: "/checkSignUp/:signUpId/:activityId",
            name: "checkSignUp",
            props: true,
            meta: {
                title: "报名回执表详情",
            },
            component: () => import("page/xSchool/receiptTableDetail.vue"),
        },
        // 个人培训报名表
        {
            path: "/trainSignTable/:signUpId/:planId",
            name: "trainSignTable",
            props: true,
            meta: {
                title: "个人培训报名表",
            },
            component: () => import("page/xSchool/trainSign/trainSignUpTable.vue"),
        },
        {
            path: "/trainSignUpTable/neiBu/:signUpId/:planId",
            name: "trainSignUpTableNeiBu",
            props: true,
            meta: {
                title: "个人培训报名表",
            },
            component: () => import("page/xSchool/trainSign/trainSignUpTableNeiBu.vue"),
        },
        {
            path: "/trainSignEdit/:signUpId",
            name: "trainSignEdit",
            props: true,
            meta: {
                title: "个人培训报名编辑",
            },
            component: () => import("page/xSchool/trainSign/trainSignEdit.vue"),
        },
        {
            path: "/trainSignDetail/:signUpId",
            name: "trainSignDetail",
            props: true,
            meta: {
                title: "个人培训报名详情",
            },
            component: () => import("page/xSchool/trainSign/trainSignDetail.vue"),
        },
        // 等级认证考试中心申请表
        {
            path: "/examCenterTable/:certificateId",
            name: "examCenterTable",
            props: true,
            meta: {
                title: "等级认证考试中心申请表",
                userType: [utTeacher],
                requiresAuth: true,
            },
            component: () => import("page/xSchool/examCenter/applyTable.vue"),
        },
        {
            path: "/editerExamTable/:tableId",
            name: "editerExamTable",
            props: true,
            meta: {
                title: "编辑等级考试申请表",
                userType: [utTeacher,utMSchool],
                requiresAuth: true,
            },
            component: () => import("page/xSchool/examCenter/editTable.vue"),
        },
        {
            path: "/examTableDetail/:tableId",
            name: "examTableDetail",
            props: true,
            meta: {
                title: "等级考试申请表详情",
                userType: [utMSystem,utEJSystem],
                requiresAuth: true,
            },
            component: () => import("page/xSchool/examCenter/applyTableDetail.vue"),
        },
        {
            path: "/meetRegisterNew/:meetId",
            name: "meetSignUpDetailNew",
            props: true,
            component: () => import("page/xSchool/meetDetailNew.vue"),
            meta: {
                title: "会议报名详情",
            },
        },
        {
            path: "/committeeTable/:userId",
            name: "committeeTable",
            props: true,
            component: () => import("page/xSchool/committee/committeeTable.vue"),
            meta: {
                title: "委员会申报",
            },
        },
        {
            path: "/committeeEdit/:committeeId",
            name: "committeeEdit",
            props: true,
            component: () => import("page/xSchool/committee/committeeEdit.vue"),
            meta: {
                title: "委员会申报编辑",
            },
        },
        {
            path: "/committeeDetail/:committeeId",
            name: "committeeDetail",
            props: true,
            component: () => import("page/xSchool/committee/committeeDetail.vue"),
            meta: {
                title: "委员会申报详情",
            },
        },
        {
            path: "/certifyQuery",
            name: "certifyQuery",
            props: true,
            component: () => import("page/xSchool/certifyQuery.vue"),
            meta: {
                title: "证书查询",
            },
        },
        {
            path: "/candidateTable",
            name: "candidateTable",
            props: true,
            component: () => import("page/xSchool/manager/candidateTable.vue"),
            meta: {
                title: "候选人推荐表",
            },
        },
        {
            path: "/candidateTableEdit/:id/:isedit",
            name: "candidateTableEdit",
            props: true,
            component: () => import("page/xSchool/manager/candidateTableEdit.vue"),
            meta: {
                title: "候选人推荐表编辑",
            },
        },
        {
            path: "/candidateTableEditTwo/:id/:isedit",
            name: "candidateTableEditTwo",
            props: true,
            component: () => import("page/xSchool/manager/candidateTableEditTwo.vue"),
            meta: {
                title: "候选人推荐表编辑",
            },
        },
        {
            path: "/rcommendaTable",
            name: "rcommendaTable",
            props: true,
            component: () => import("page/xSchool/manager/rcommendaTable.vue"),
            meta: {
                title: "全国候选人推荐表",
            },
        },
        {
            path: "/rcommendaTableEdit/:id/:isedit",
            name: "rcommendaTableEdit",
            props: true,
            component: () => import("page/xSchool/manager/rcommendaTableEdit.vue"),
            meta: {
                title: "全国候选人推荐表编辑",
            },
        },
        // 证书查询
        {
            path: "/certify",
            name: "certifyIndex",
            props: true,
            component: () => import("page/newCertyificate/index.vue"),
            meta: {
                title: "证书查询首页",
            },
        },
        {
            path: "/certifyResult/:type",
            name: "certifyResult",
            props: true,
            component: () => import("page/newCertyificate/certifyQuery.vue"),
            meta: {
                title: "证书查询",
            },
        },
        {
            path: "/certifyQueryNew/:type",
            name: "certifyQueryNew",
            props: true,
            component: () => import("page/newCertyificate/certifyQueryNew.vue"),
            meta: {
                title: "新证书查询",
            },
        },
        {
            path: "/teachersQuery/:type",
            name: "teachersQuery",
            props: true,
            component: () => import("page/newCertyificate/teachersQuery.vue"),
            meta: {
                title: "师资证书查询",
            },
        },
        {
            path: "/teachersQueryNew/:type",
            name: "teachersQueryNew",
            props: true,
            component: () => import("page/newCertyificate/teachersQueryNew.vue"),
            meta: {
                title: "新师资证书查询",
            },
        },
        {
            path: "/phLogin",
            name: "phLogin",
            props: true,
            component: () => import("page/phLogin.vue"),
            meta: {
                title: "移动端登录",
            },
        },
        {
            path: "/retrievePassword/:schoolId?",
            name: "retrievePassword",
            props: true,
            component: () => import("page/retrievePassword.vue"),
            meta: {
                title: "移动端忘记密码",
            },
        },
        {
            path: "/phRegister/:schoolId?",
            name: "phRegister",
            props: true,
            component: () => import("page/phRegister.vue"),
            meta: {
                title: "移动端账号注册",
            },
        },
        {
            path: "/selectSchool/:type",
            name: "selectSchool",
            props: true,
            component: () => import("page/selectSchoolList.vue"),
            meta: {
                title: "移动端选择学校",
            },
        },
        {
            path: "/applySchool",
            name: "applySchool",
            props: true,
            component: () => import("page/applySchool.vue"),
            meta: {
                title: "移动端学校申请",
            },
        },
        {
            path: "/managerIndex",
            name: "managerIndex",
            props: true,
            component: () => import("page/xSchool/managerCom/managerIndex.vue"),
            meta: {
                requiresAuth: true,
                userType: [utMSystem,utEJSystem, utTeacher],
                title: "后台管理首页",
            },
        },
        {
            path: "/TecInfoData/:id",
            name: "TeacherProfile",
            props: true,
            component: () => import("page/xSchool/managerCom/TecInfoDatabank.vue"),
            meta: {
                requiresAuth: true,
                userType: [utTeacher],
                title: "教师账户设置",
            },
        },
        {
            path: "/schoolStatic",
            name: "schoolStatic",
            props: true,
            component: () => import("page/xSchool/graduateStatic/schooStatic.vue"),
            meta: {
                // requiresAuth: true,
                userType: [utMSystem,utEJSystem],
                title: "院校就业统计",
            },
        },
        {
            path: "/enterpriseStatic",
            name: "enterpriseStatic",
            props: true,
            component: () => import("page/xSchool/graduateStatic/enterpriseStatic.vue"),
            meta: {
                // requiresAuth: true,
                userType: [utMSystem,utEJSystem],
                title: "企业就业统计",
            },
        },
        {
            path: "/schoolStaticEdit/:sid",
            name: "schoolStaticEdit",
            props: true,
            component: () => import("page/xSchool/graduateStatic/schooStaticEdit.vue"),
            meta: {
                // requiresAuth: true,
                userType: [utMSystem,utEJSystem],
                title: "院校就业统计修改",
            },
        },
        {
            path: "/enterpriseStaticEdit/:eid",
            name: "enterpriseStaticEdit",
            props: true,
            component: () => import("page/xSchool/graduateStatic/enterpriseStaticEdit.vue"),
            meta: {
                // requiresAuth: true,
                userType: [utMSystem,utEJSystem],
                title: "企业就业统计修改",
            },
        },
        {
            path: "/assistanceStu",
            name: "assistanceStu",
            props: true,
            component: () => import("page/xSchool/assistanceStu.vue"),
            meta: {
                title: "助力物流学子就业信息网",
            },
        },
        {
            path: "/jobsNeedList",
            name: "jobsNeedList",
            props: true,
            component: () => import("page/xSchool/jobsNeedList.vue"),
            meta: {
                title: "招聘岗位列表",
            },
        },
        {
            path: "/queryHome",
            name: "queryHome",
            component: () => import("page/CertificateQuery/queryHome.vue"),
            meta: {
                title: "证书成绩查询手机"
            }
        },
        {
            path: "/demo",
            name: "demo",
            component: () => import("page/newCertyificate/demo.vue")
        },
        ...managerRouter,
        // {
        //     path: '/wlx/:bookId/bookCenter',
        //     name: 'phoneTeachingDetails',
        //     props: true,
        //     component: () =>
        //         import ('page/xSchool/teachingDetails.vue'),
        //     meta: {
        //         title: '教材详情'
        //     },
        // },
        // {
        //     path: '/wlx/:resId/bookDetail',
        //     name: 'phoneBook',
        //     props: true,
        //     component: () =>
        //         import ('page/xSchool/work.vue'),
        //     meta: {
        //         title: '教材详情-作业'
        //     },
        // },
    ],
    linkActiveClass: "linkActive",
    scrollBehavior(to, from, savedPosition) {
        // return 期望滚动到哪个的位置
        return { x: 0, y: 0 };
    },
});

// 全局拦截路由
router.beforeEach((to, from, next) => {
    // 获取登录状态
    const auth = store.state.auth;
    // 验证是否需要权限
    to.matched.forEach((record) => {
        if (record.meta.requiresAuth) {
            // 没有用户信息
            // 常见情况:
            // 1.用户强制刷新了页面, 需要重新发送用户登录信息请求
            // 2.用户没有登录直接拷贝的地址粘贴
            if (auth.code === -101) {
                // 之前没有加载用户信息
                let request = auth.request || store.dispatch(MU_UPATE_AUTH);
                request.then((rst) => {
                    // 路由之后
                    // 确定没有登录
                    next(afterAuth(to, rst, record) || undefined);
                });
            } else {
                // 路由之后
                next(afterAuth(to, auth, record) || undefined);
            }
        } else {
            // 不需要验证的路由
            next(); // 确保一定要调用 next()
        }
    });
    if (location.href.indexOf("/bookCenter") || location.href.indexOf("/bookDetail")) {
        window.document.title = "";
    }
});

/**
 * 路由跳转验证
 * 没有登录或者用户类型不匹配
 *
 * @param {IAuth} auth
 * @param {RouteRecord} record
 * @returns {boolean}
 */
function requiresAuth(auth, record) {
    // 返回需要验证的情况:
    // 1.没有登录
    // 2.用户类型定义并且用户类型和对应的路由要求不匹配

    // 还没登录、跳转到登录页
    if (auth.code < 0) {
        return true;
    }

    // meta设置了userType字段, 需要验证身份
    if (record.meta.userType !== undefined) {
        if (typeof record.meta.userType === "number") {
            // 只需一种角色进入
            // 不满足、跳转登录页
            return auth.userType !== record.meta.userType;
        } else if (record.meta.userType instanceof Array) {
            // 允许多重角色
            // 不满足、跳转登录页
            return record.meta.userType.indexOf(auth.userType) === -1;
        } else {
            // 其他情况均跳转到登录页
            return true;
        }
    } else {
        // 没有设置设置meta的userType字段
        // 放过进入下一个路由
        return false;
    }
}

function afterAuth(to, auth, record) {
    // 已经请求过用户信息
    if (requiresAuth(auth, record)) {
        // 普通页面调转，没有丢失用户登录信息
        return {
            name: "xIndex", // 原来是login
            query: { redirect: to.fullPath },
        };
    } else {
        return false;
    }
}

export default router;
